import { observer } from "mobx-react";
import banner from "../assets/banner.jpg";
import Footer from "./Footer";

const Main = observer(({ screen }) => {
  return (
    <div className="container-fluid px-0 mb-5">
      <div className="row mb-5">
        <div className="col-12">
          <img src={banner} alt="Banner" />
        </div>
      </div>
      <div className="container">
        <div className="row d-flex justify-content-center">
          {screen}
        </div>
      </div>
      <Footer />
    </div>
  );
});
export default Main;
